namespace GeniuzPOS.ReportMasterData {
    export interface Report_1105Form {
        MbId: Serenity.LookupEditor;
        MbNameT: Serenity.StringEditor;
        MbAccumPoint: Serenity.DecimalEditor;
        MbNearlyExpirePoint: Serenity.DecimalEditor;
        MbExpirePointDate: Serenity.DateEditor;
        MbCardStatus: Serenity.IntegerEditor;
        MbExpireDate: Serenity.DateEditor;
        MbProvince: Serenity.StringEditor;
        MbAmphur: Serenity.StringEditor;
        MbTumbol: Serenity.StringEditor;
    }

    export class Report_1105Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1105';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1105Form.init)  {
                Report_1105Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = s.IntegerEditor;

                Q.initFormType(Report_1105Form, [
                    'MbId', w0,
                    'MbNameT', w1,
                    'MbAccumPoint', w2,
                    'MbNearlyExpirePoint', w2,
                    'MbExpirePointDate', w3,
                    'MbCardStatus', w4,
                    'MbExpireDate', w3,
                    'MbProvince', w1,
                    'MbAmphur', w1,
                    'MbTumbol', w1
                ]);
            }
        }
    }
}
